<template>
  <div>
    <b-form
      class="needs-validation"
      novalidate
      id="form-add-address"
      @submit.prevent="saveTexInvoiceAddress"
    >
      <div class="form-scroll">
        <b-row>
          <b-col cols="12" lg="6" class="mb-20">
            <label for="company_name">{{ $t('userDashboard.paymentHistory.formAddress.company') }}</label>
            <b-form-input
              v-model="dataForm.company_name"
              id="company_name"
              :placeholder="$t('userDashboard.paymentHistory.formAddress.company')"
              name="company_name"
              :class="{ 'is-invalid': $v.dataForm.company_name.$error }"
            ></b-form-input>
            <b-form-invalid-feedback>{{ $t('userDashboard.paymentHistory.error.company') }}</b-form-invalid-feedback>
          </b-col>
          <b-col cols="12" lg="6" class="mb-20">
            <label for="tax_id">{{ $t('userDashboard.paymentHistory.formAddress.tax_id') }}</label>
            <b-form-input
              v-model="dataForm.taxid"
              id="tax_id"
              :placeholder="$t('userDashboard.paymentHistory.formAddress.tax_id')"
              name="tax_id"
              :class="{ 'is-invalid': $v.dataForm.taxid.$error }"
            ></b-form-input>
            <b-form-invalid-feedback>{{ $t('userDashboard.paymentHistory.error.tax') }}</b-form-invalid-feedback>
          </b-col>
          <b-col cols="12" lg="6" class="mb-20">
            <label for="first_name">{{ $t('userDashboard.paymentHistory.formAddress.name') }}</label>
            <b-form-input
              v-model="dataForm.first_name"
              id="first_name"
              :placeholder="$t('userDashboard.paymentHistory.formAddress.name')"
              name="first_name"
              :class="{ 'is-invalid': $v.dataForm.first_name.$error }"
            ></b-form-input>
            <b-form-invalid-feedback>{{ $t('userDashboard.paymentHistory.error.frstName') }}</b-form-invalid-feedback>
          </b-col>
          <b-col cols="12" lg="6" class="mb-20">
            <label for="last_name">{{ $t('userDashboard.paymentHistory.formAddress.surname') }}</label>
            <b-form-input
              v-model="dataForm.last_name"
              id="last_name"
              :placeholder="$t('userDashboard.paymentHistory.formAddress.surname')"
              name="last_name"
              :class="{ 'is-invalid': $v.dataForm.last_name.$error }"
            ></b-form-input>
            <b-form-invalid-feedback>{{ $t('userDashboard.paymentHistory.error.lastName') }}</b-form-invalid-feedback>
          </b-col>
          <b-col cols="12" lg="12" class="mb-20">
            <label for="address">{{ $t('userDashboard.paymentHistory.formAddress.address.name') }}</label>
            <b-form-input
              v-model="dataForm.address"
              id="address"
              :placeholder="$t('userDashboard.paymentHistory.formAddress.address.placeholder')"
              name="address"
              :class="{ 'is-invalid': $v.dataForm.address.$error }"
            ></b-form-input>
            <b-form-invalid-feedback>{{ $t('userDashboard.paymentHistory.error.address') }}</b-form-invalid-feedback>
          </b-col>
          <b-col cols="12" lg="6" class="mb-20">
            <label for="zip_code">{{ $t('userDashboard.paymentHistory.formAddress.post_code') }}</label>
            <b-form-input
              v-model="dataForm.zipcode"
              id="zip_code"
              :placeholder="$t('userDashboard.paymentHistory.formAddress.post_code')"
              name="zip_code"
              :class="{ 'is-invalid': $v.dataForm.zipcode.$error }"
            ></b-form-input>
            <b-form-invalid-feedback>{{ $t('userDashboard.paymentHistory.error.zipcode') }}</b-form-invalid-feedback>
          </b-col>
          <b-col cols="12" lg="6" class="mb-20">
            <label for="province">{{ $t('userDashboard.paymentHistory.formAddress.province') }}</label>
            <b-dropdown class="input-choose" :class="{ 'is-invalid': $v.selectedProvince.$error }" no-flip>
              <template v-slot:button-content>
                <span>
                  {{selectedProvince ? selectedProvince.name : $t('userDashboard.paymentHistory.formAddress.province') }}
                  <ChevronDownIcon />
                </span>
              </template>
              <b-dropdown-item
                @change.native="getAmphures(province)"
                @click.native="getAmphures(province)"
                v-for="province in provinces"
                :key="province.id"
              >{{ province.name }}</b-dropdown-item>
            </b-dropdown>
            <b-form-invalid-feedback>{{ $t('userDashboard.paymentHistory.error.province') }}</b-form-invalid-feedback>
          </b-col>
          <b-col cols="12" lg="6" class="mb-20">
            <label for="state">{{ $t('userDashboard.paymentHistory.formAddress.state') }}</label>

            <b-dropdown class="input-choose" :class="{ 'is-invalid': $v.selectedAmphure.$error  }" no-flip>
              <template v-slot:button-content>
                <span>
                  {{selectedAmphure ? selectedAmphure.name : $t('userDashboard.paymentHistory.formAddress.state') }}
                  <ChevronDownIcon />
                </span>
              </template>
              <b-dropdown-item
                @change.native="getDistricts(amphure)"
                @click.native="getDistricts(amphure)"
                v-for="amphure in amphures"
                :key="amphure.id"
              >{{ amphure.name }}</b-dropdown-item>
            </b-dropdown>
            <b-form-invalid-feedback>{{ $t('userDashboard.paymentHistory.error.district') }}</b-form-invalid-feedback>
          </b-col>
          <b-col cols="12" lg="6">
            <label for="area">{{ $t('userDashboard.paymentHistory.formAddress.area') }}</label>
            <b-dropdown class="input-choose" :class="{ 'is-invalid': $v.selectedDistrict.$error}" no-flip>
              <template v-slot:button-content>
                <span>
                  {{selectedDistrict ? selectedDistrict.name : $t('userDashboard.paymentHistory.formAddress.area') }}
                  <ChevronDownIcon />
                </span>
              </template>
              <b-dropdown-item
                @click="selectedDistrict = district"
                v-for="district in distrists"
                :key="district.id"
              >{{ district.name }}</b-dropdown-item>
            </b-dropdown>
            <b-form-invalid-feedback>{{ $t('userDashboard.paymentHistory.error.subDistrict') }}</b-form-invalid-feedback>
          </b-col>
        </b-row>
      </div>
      <b-col cols="12" class="mt-70 text-center">
        <b-button
          v-if="!loading"
          class="btn-save"
          type="submit"
        >{{ $t('userDashboard.paymentHistory.formAddress.btnRecord') }}</b-button>
        <b-spinner v-else label="Loading..." variant="light"></b-spinner>
      </b-col>
    </b-form>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import * as actionType from "../../../controllers/ActionTypes";
import ChevronDownIcon from "vue-material-design-icons/ChevronDown.vue";
import { required, email, minLength } from "vuelidate/lib/validators";
export default {
  name: "invoiceAddress",
  components: {
    ChevronDownIcon,
  },
  props: {},
  data() {
    return {
      area_params: {
        take: -1,
      },
      loading: false,
      selectedProvince: "",
      selectedAmphure: "",
      selectedDistrict: "",
      dataForm: {
        company_name: "",
        taxid: "",
        first_name: "",
        last_name: "",
        address: "",
        zipcode: "",
      },
    };
  },
  computed: {
    ...mapGetters("UserController", ["isTablet"]),
    ...mapState("CategoryController", ["provinces", "distrists", "amphures"]),
  },
  mounted: function () {
    this.fetchInvoiceAddress();
    if (this.provinces.lenght !== 0) {
      this.getProvinces();
    }
  },
  validations: {
    dataForm: {
      company_name: { min: minLength(5) },
      taxid: { min: minLength(5) },
      first_name: { required, min: minLength(3) },
      last_name: { required, min: minLength(3) },
      address: { required, min: minLength(5) },
      zipcode: { required, min: minLength(3) },
    },
    selectedProvince: { required },
    selectedAmphure: { required },
    selectedDistrict: { required },
  },

  methods: {
    ...mapActions("PaymentController", [
      actionType.FETCH_INVOICE_ADDRESS,
      actionType.UPDATE_INVOICE_ADDRESS,
    ]),
    ...mapActions("CategoryController", [
      actionType.GET_DATA_PROVINCES,
      actionType.GET_DATA_DISTRISTS,
      actionType.GET_DATA_AMPHURES,
    ]),
    getProvinces() {
      this.GET_DATA_PROVINCES(this.area_params);
    },
    getAmphures(province) {
      this.selectedProvince = province;
      this.selectedAmphure = null;
      this.selectedDistrict = null;
      this.GET_DATA_AMPHURES({ ...this.area_params, province_id: province.id });
    },
    getDistricts(amphure) {
      this.selectedAmphure = amphure;
      this.selectedDistrict = null;
      this.GET_DATA_DISTRISTS({
        ...this.area_params,
        amphure_id: amphure.id,
        province_id: this.selectedProvince.id,
      });
    },
    saveTexInvoiceAddress() {
      this.$v.dataForm.$touch();
      
      if (this.$v.dataForm.$error) {
        
        return;
      }
      var vm = this;
      vm.loading = true;
      vm.UPDATE_INVOICE_ADDRESS({
        ...vm.dataForm,
        province_id: vm.selectedProvince.id,
        area_id: vm.selectedAmphure.id,
        district_id: vm.selectedDistrict.id,
      })
        .then(function (response) {
          vm.loading = false;
          vm.$bvToast.toast($t(payment.invoiceAddressUpdate), {
            title: $t(payment.invoiceAddressUpdate),
            variant: 'success',
            solid: true
          });
        })
        .catch(function (error) {
          vm.loading = false;
          vm.$bvToast.toast($t(payment.tryAgain), {
            title: $t(payment.tryAgain),
            variant: 'error',
            solid: true
          });
        });
    },
    fetchInvoiceAddress() {
      var vm = this;
      vm.loading = true;
      vm.FETCH_INVOICE_ADDRESS()
        .then(function (response) {
          response = response.data;
          vm.loading = false;
          vm.dataForm.company_name = response.company_name;
          vm.dataForm.taxid = response.taxid;
          vm.dataForm.first_name = response.first_name;
          vm.dataForm.last_name = response.last_name;
          vm.dataForm.address = response.address;
          vm.dataForm.zipcode = response.zipcode;
          vm.selectedProvince = response.province;
          
          
          if (vm.selectedProvince) {
            vm.getAmphures(vm.selectedProvince);
            vm.selectedAmphure = response.amphure;
          }
          if (vm.selectedAmphure) {
            vm.getDistricts(vm.selectedAmphure);
            vm.selectedDistrict = response.district;
          }
        })
        .catch(function (error) {
          vm.loading = false;
        });
    },
  },
};
</script>